export function toNumber(value) {
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function toCents(value) {
  return Math.round(toNumber(value) * 100);
}

export function fromCents(cents) {
  return cents / 100;
}

export function safeSum(...values) {
  const totalCents = values.reduce((acc, v) => acc + toCents(v), 0);
  return fromCents(totalCents);
}

export function roundTwo(value) {
  return Math.round(toNumber(value) * 100) / 100;
}

export function formatUSD(value) {
  const rounded = roundTwo(value);
  // Show decimals only when necessary (up to 2)
  if (Number.isInteger(rounded)) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(rounded);
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(rounded);
}

export function formatSmartNumber(value) {
  const rounded = roundTwo(value);
  if (Number.isInteger(rounded)) {
    return rounded.toLocaleString('en-US');
  }
  return rounded.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export default {
  toNumber,
  toCents,
  fromCents,
  safeSum,
  roundTwo,
  formatUSD,
  formatSmartNumber
};


